<template>
  <svg
    :class="svgClass"
    aria-hidden="true"
    v-bind="$attrs"
    :style="customStyle"
    viewBox="0 0 24 24"
  >
    <use :xlink:href="iconName" />
  </svg>
</template>

<script>
export default {
  name: 'SvgIcon',
  inheritAttrs: false, // 防止属性传递给根元素
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    className: {
      type: String,
      default: '',
    },
    customStyle: {
      type: String, // 建议改为 Object 类型，或者保持 String 但使用时注意
      default: '',
    },
    fill: {
      type: String,
      default: '',
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className;
      } else {
        return 'svg-icon';
      }
    },
    styleObject() {
      // 如果 customStyle 是字符串，转换为对象
      if (typeof this.customStyle === 'string') {
        try {
          return JSON.parse(this.customStyle);
        } catch {
          return {};
        }
      }
      return this.customStyle || {};
    },
  },
};
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.svg-icon use {
  width: 100%;
  height: 100%;
}
</style>
